// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xml:space='preserve'
    width='800'
    height='800'
    fill='var(--icon-color, #000000)'
    viewBox='0 0 490 490'
    ...attributes
  ><path
      d='M122.5 34.031 0 245.001l122.5 210.968h245L490 245.001 367.5 34.031zm165.058 284.262h-85.116l-42.557-73.292 42.557-73.292h85.116l42.557 73.292z'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'IconHexagon';
export default IconComponent;
